import React, { useState } from 'react';
import './Contact.css';
import instaIcon from '../assets/insta.jpeg';
// Import required libraries for Formspark and Botpoison
import { submitFormspark } from '../utils/formspark';
import MarketingConsent from '../components/MarketingConsent';

const scrollToTop = () => {
  if (typeof window !== 'undefined') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
    message: '',
    marketingOptIn: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error', or null

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      await submitFormspark({
        form: 'contact',
        fullName: formData.fullName,
        email: formData.email,
        phoneNumber: formData.phoneNumber,
        message: formData.message,
        marketingOptIn: formData.marketingOptIn ? 'Yes' : 'No'
      });

      setSubmitStatus('success');
      scrollToTop();
      // Reset form after successful submission
      setFormData({
        fullName: '',
        email: '',
        phoneNumber: '',
        message: '',
        marketingOptIn: false
      });
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
      scrollToTop();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-info">
        <p className="contact-phone">For Questions Call: <a href="tel:650-409-9676">650-409-9676</a></p>
        <p className="contact-address">1101 San Carlos Ave. 94070</p>
      </div>
      
      <h1 className="contact-title">Connect with Us</h1>
      <div className="social-links">
        <a 
          href="https://www.instagram.com/drakes_san_carlos/?hl=en"
          target="_blank"
          rel="noopener noreferrer"
          className="instagram-button"
        >
          <img src={instaIcon} alt="Instagram" className="instagram-icon" />
          Follow us on Instagram
        </a>
      </div>
      <p className="contact-subtitle">Please complete the form below and we'll get back to you as soon as we can.</p>
      
      {submitStatus === 'success' && (
        <div className="success-message">
          Thank you! Your message has been sent successfully. We'll get back to you soon.
        </div>
      )}
      
      {submitStatus === 'error' && (
        <div className="error-message">
          Sorry, there was an error sending your message. Please try again or call us directly.
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-group">
          <label htmlFor="fullName">Full Name<span className="required">*</span></label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="Full Name"
            required
            disabled={isSubmitting}
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email<span className="required">*</span></label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email"
            required
            disabled={isSubmitting}
          />
        </div>

        <div className="form-group">
          <label htmlFor="phoneNumber">Phone Number<span className="required">*</span></label>
          <input
            type="tel"
            id="phoneNumber"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            placeholder="(555) 555-5555"
            required
            disabled={isSubmitting}
          />
        </div>

        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows="4"
            placeholder="Your message here..."
            disabled={isSubmitting}
          />
        </div>

        <MarketingConsent
          id="contact-marketing-opt-in"
          checked={formData.marketingOptIn}
          onChange={handleChange}
          disabled={isSubmitting}
        />

        <button type="submit" className="submit-button" disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      </form>
    </div>
  );
};

export default Contact; 